<div
  class="library-folder-row"
  [class.active]="currentlySelected?.id === folder.id"
  [class.tree-view-mode]="useTreeView"
  [attr.data-node-level]="nodeLevel"
  [style.--node-level]="nodeLevel">
  <span
    [attr.aria-label]="getAriaLabel()"
    [attr.data-tree-node-key]="null"
    [attr.tabindex]="useTreeView ? null : '0'"
    (keyup.enter)="!useTreeView && expandFolder(folder)"
    data-cy="collection-folder"
    [attr.aria-expanded]="useTreeView ? null : isExpanded()"
    (click)="expandFolder(folder)"
    [class.withMargin]="multiSelect || !managedCollectionAccess()"
    class="library-folder-info">
    <i
      class="folder-icon"
      [class.ficon-folder-open]="isExpanded()"
      [class.ficon-folder-filled]="!isExpanded()">
    </i>
    <span class="collection-folder-name">
      {{folder.name}}
    </span>
    <span class="collection-folder-modified-date">
      {{ formatDate(folder.updated_at) }}
    </span>
  </span>
  @if (!multiSelect && managedCollectionAccess()) {
    <button
      type="button"
      [matMenuTriggerFor]="menu"
      data-cy="collection-folder-menu"
      class="btn-none collection-folder-menu folder-options-dropdown-menu"
      [attr.aria-label]="'collection-folder-menu' | translate">
      <i class="ficon-app-dots-vertical"></i>
    </button>
  }
  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      class="edit-folder-button"
      type="button"
      data-cy="common-rename"
      (click)="openEditFolderModal()">
      <span translate="common_rename"></span>
    </button>
    <button
      mat-menu-item
      class="remove-option"
      type="button"
      data-cy="common-remove"
      (click)="removeFolder(folder)">
      <span translate="common_remove"></span>
    </button>
  </mat-menu>
  @if (useTreeView && isFolderLoading()) {
    <div class="loading-indicator-row">
      <mat-progress-bar [attr.aria-label]="'common_loading'| translate" mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>

@if (!useTreeView) {
  @if (expandedFolders.includes(folder.id)) {
    <div
      class="library-folder-expanded"
      >
      @for (item of filteredItems | sort:getSortKey(); track item) {
        <ngx-collection-item-viewer
          class="collection-item"
          [class.active]="expanded.includes(item.hash)"
          [item]="item"
          [expanded]="expanded"
          [mode]="mode"
          (selectItem)="selectItem.emit($event)"
          [collections]="collections"
          [orgSettings]="orgSettings"
          [archiveCollection]="archiveCollection"
          [selectedCollection]="selectedCollection"
          [selectedContentType]="selectedContentType"
          (loadNewItems)="loadNewItems.emit($event)"
          [collectionItems]="collectionItems"
          [items]="filteredItems"
          (updateItems)="updateItems()"
          [multiSelect]="multiSelect"
          (setSelectAllChecked)="setSelectAllChecked.emit($event)"
          [expandedHeight]="expandedHeight"
          [currentlySelected]="currentlySelected"
          (setActivityPanelIsOpen)="setActivityPanelIsOpen.emit($event)"
          (setCurrentlySelected)="setCurrentlySelected.emit($event)"
        ></ngx-collection-item-viewer>
      }
      @if (!filteredItems.length) {
        <div
          class="collection-folder-zero-state"
          translate="collection-folder-no-items">
        </div>
      }
    </div>
  }
}
